import { t } from "i18next";

export default function printError(str) {
  if (typeof str !== "string") return t("common.error.somethingWentWrong");
  return str ?? t("common.error.somethingWentWrong");
}
